// src/context/UserContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

const UserContext = createContext(null);

function getLogin() {
  const idToken = localStorage.getItem("id_token");
  if (idToken) {
    try {
      const decoded = jwtDecode(idToken);
      return {
        userId: decoded.identities?.[0]?.userId || "User",
        email: decoded.identities?.email || "",
      };
    } catch (error) {
      console.error("Failed to decode token:", error);
      return { userId: "User", email: "" };
    }
  }
  return { userId: "User", email: "" };
}

export function UserProvider({ children }) {
  const [user, setUser] = useState(() => getLogin());

  useEffect(() => {
    // Re-read if token changes
    setUser(getLogin());
  }, []);

  return (
    <UserContext.Provider value={user}>
      {children}
    </UserContext.Provider>
  );
}

// ✅ Custom hook for easy access anywhere
export function useUser() {
  const context = useContext(UserContext);
  if (context === null) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
}